
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account-transfer",
      function () {
        return require("private-next-pages/account-transfer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account-transfer"])
      });
    }
  